import { ICreateUpdateRole } from '../interfaces'
import { Tooltip } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { Status } from 'components/atoms'
import Actions, { ActionType } from 'components/atoms/actions'
import { ActionDisable, ActionsEditDelete } from 'constants/actionsType'
import { NO_DATA } from 'constants/common'
import { useColumnFactory } from 'hooks'
import { t } from 'i18next'
import { DivIndex } from 'styles/styledGlobal'
import { formatDate } from 'utils'

const useColumnService = (
  offset: number,
  totalRecord: number,
  onAction: (type: ActionType, row: ICreateUpdateRole) => void
) => {
  const { createColumns } = useColumnFactory<ICreateUpdateRole>()
  const getColumns = (): ColumnsType<ICreateUpdateRole> => [
    {
      title: 'hash',
      dataIndex: 'hash',
      align: 'center',
      width: 80,
      render: (id, row, index) => <DivIndex>{index + 1 + offset}</DivIndex>
    },
    {
      title: 'role',
      dataIndex: 'role',
      align: 'left',
      showSorterTooltip: false,
      defaultSortOrder: 'ascend',
      render: (role) => {
        return (
          <Tooltip title={role} color="white" placement="topLeft">
            {role || NO_DATA}
          </Tooltip>
        )
      }
    },
    {
      title: 'description',
      dataIndex: 'description',
      align: 'left',
      render: (des) => {
        return (
          <Tooltip title={des} color="white" placement="topLeft">
            {des || NO_DATA}
          </Tooltip>
        )
      }
    },
    {
      title: 'access-function',
      dataIndex: 'permission',
      width: 280,
      align: 'left',
      render: (permission, row) => {
        const isSysadmin = row.role?.toLowerCase() === 'sysadmin'
        const permission2 = {
          account_management: permission.account_management,
          category_management: permission.category_management,
          patient_management: permission.patient_management,
          examination: permission.examination,
          warehouse_management: permission.warehouse_management
        }
        const permissionNames = Object.entries(permission2)
          .filter(([_, value]) =>
            typeof value === 'object'
              ? Object.values(value as any).some((v) => v)
              : value
          )
          .map(([key]) => t(key))
          .join(', ')
        return (
          <Tooltip title={permissionNames} color="white" placement="topLeft">
            {isSysadmin ? t('full-access') : permissionNames || NO_DATA}
          </Tooltip>
        )
      }
    },
    {
      title: 'created-at',
      dataIndex: 'created_at',
      render: (date: Date) => formatDate(date)
    },
    {
      title: 'status',
      dataIndex: 'status',
      width: 180,
      render: (status: number) => (
        <Status
          statusColor={status === 2 ? 'green' : 'red'}
          title={status === 2 ? t('active') : t('de-active')}
        />
      )
    },
    {
      title: 'action',
      dataIndex: 'action',
      align: 'center',
      width: 80,
      render: (value, row) => {
        const isSysadmin = row.role?.toLowerCase() === 'sysadmin'
        return (
          <Actions
            actions={isSysadmin ? ActionDisable : ActionsEditDelete}
            onClick={(actionType) => onAction(actionType, row)}
          />
        )
      }
    }
  ]

  return {
    columns: createColumns(getColumns())
  }
}

export default useColumnService
